var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"title-box clickable",attrs:{"to":("/reports/" + (_vm.report.tableauMenuConfigId))}},[_c('b-icon-file-earmark-bar-graph'),_vm._v(" "+_vm._s(_vm.report.title)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }